<div class="layout" [ngClass]="{ priority: priority }">
  <ng-content *ngIf="hierarchie.length === 0"></ng-content>
  <span
    *ngFor="let item of hierarchie; index as i"
    [class]="'master ' + 'item' + i"
    >{{ item }}</span
  >
</div>
